module.exports = __webpack_public_path__ + "img/blue3.115be038.png";